exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__disabledLink___3fckm{pointer-events:none;cursor:not-allowed;color:#c2c2c2}.style__activeLink___4dF72{background:#0581c2;color:#fff!important}.style__annotationContainer___1ZrCm{margin-top:-.34rem}", "", {"version":3,"sources":["/./containers/curateHome/style.css"],"names":[],"mappings":"AAAA,6BACC,oBAAqB,AACrB,mBAAoB,AACpB,aAAe,CACf,AAED,2BACC,mBAAoB,AACpB,oBAAwB,CACxB,AAED,oCACC,kBAAqB,CACrB","file":"style.css","sourcesContent":[".disabledLink {\n\tpointer-events: none;\n\tcursor: not-allowed;\n\tcolor: #c2c2c2;\n}\n\n.activeLink {\n\tbackground: #0581C2;\n\tcolor: white !important;\n}\n\n.annotationContainer {\n\tmargin-top: -0.34rem;\n}\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"disabledLink": "style__disabledLink___3fckm",
	"activeLink": "style__activeLink___4dF72",
	"annotationContainer": "style__annotationContainer___1ZrCm"
};


//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/css-loader?modules&sourceMap&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!/data/www/SGDBackend-Nex2/~/postcss-loader!./containers/curateHome/style.css
// module id = 554
// module chunks = 0